module.exports = __webpack_public_path__ + "media/images/tailwind/mag_glass-337b36ab9737e1c1408a3219be7ce2ca.png";